import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'decodeb64',
  standalone: true,
})
export class DecodeBase64Pipe implements PipeTransform {

  transform(value: string): string {
    if (value == null) {
      return '';
    }
    return this.tryDecode(value);
  }

  tryDecode(str: string): string {
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(new Uint8Array(atob(str).split('').map(c => c.charCodeAt(0))));
  }
}
